import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { House01Icon } from '@hugeicons/core-free-icons';
import { colour } from '../../styles/GlobalStyles';
import { X } from '../../assets/icons';
import { GHL, Zapier, Salesforce, FollowUpBoss } from '../../assets/images/crms';
import ClozersLogoMark from '../../logo-mark.svg';

// Prefer new schema (ingestion array) only
export const getPrimaryIngestionType = (automation) => {
    if (!automation) return null;
    if (Array.isArray(automation.ingestion) && automation.ingestion.length > 0) {
        return automation.ingestion[0]?.type || null;
    }
    return null;
};

// Use counters object only (new schema)
export const getAutomationCounters = (automation) => {
    if (!automation) {
        return { reports: 0, goldenLeads: 0 };
    }
    const reports = automation.counters?.reports ?? 0;
    const goldenLeads = automation.counters?.goldenLeads ?? 0;
    return { reports, goldenLeads };
};

// Get logo based on ingestion type (MLS or CRM)
export const getIngestionLogo = (isMLS, ingestionType) => {
    if (isMLS) {
        return <HugeiconsIcon icon={House01Icon} size={16} color={colour.gray06} />;
    }
    switch (ingestionType) {
        case 'x':
            return <X className="automation-card-x-logo" />;
        case 'ghl':
            return <img src={GHL} alt="Go High Level" className="automation-card-crm-logo" />;
        case 'zapier':
            return <img src={Zapier} alt="Zapier" className="automation-card-crm-logo" />;
        case 'salesforce':
            return <img src={Salesforce} alt="Salesforce" className="automation-card-crm-logo" />;
        case 'fub':
            return <img src={FollowUpBoss} alt="Follow Up Boss" className="automation-card-crm-logo" />;
        case 'api':
            return <img src={ClozersLogoMark} alt="Clozers" className="automation-card-crm-logo" />;
        default:
            return null;
    }
};

// Display name for ingestion type (matches Settings integration names)
export const getIngestionDisplayName = (ingestionType) => {
    switch (ingestionType) {
        case 'x':
            return 'X';
        case 'ghl':
            return 'Go High Level';
        case 'zapier':
            return 'Zapier';
        case 'salesforce':
            return 'Salesforce';
        case 'fub':
            return 'Follow Up Boss';
        case 'api':
            return 'Clozers API';
        default:
            return ingestionType || 'Integration';
    }
};

// Summary for Output section (destination + notifications)
export const getOutputSummary = (automation, isMLS) => {
    const notificationConfig = automation.output?.notifications || {};
    const recipients = Array.isArray(notificationConfig.recipients)
        ? notificationConfig.recipients
        : [];
    const emailCount = recipients.filter(r => r?.emailEnabled === true).length;
    const smsCount = recipients.filter(r => r?.smsEnabled === true).length;
    
    let notifText = 'Not configured';
    const parts = [];
    if (emailCount > 0) {
        parts.push(`Email to ${emailCount} user${emailCount === 1 ? '' : 's'}`);
    }
    if (smsCount > 0) {
        parts.push(`Text to ${smsCount} user${smsCount === 1 ? '' : 's'}`);
    }
    if (parts.length > 0) {
        notifText = parts.join(' · ');
    }
    
    const ingestionType = getPrimaryIngestionType(automation);
    const ingestionTypeName = isMLS
        ? 'MLS'
        : (ingestionType === 'ghl'
            ? 'High Level'
            : ingestionType === 'x'
                ? 'X'
                : ingestionType || 'Not set');
    
    return { ingestionTypeName, notifText };
};
